export default {
	routes: {
		shop: {
			path: '/shop',
			slug: 'shop',
			name: 'shop',
			headerMenu: true,
			autoload: true,
		},

		shopMen: {
			path: '/shop/men',
			slug: 'catalog/men',
			name: 'catalogMen',
			headerMenu: false,
			autoload: true,
			postType: {
				slug: 'products/men',
				name: 'catalogMenProducts',
				queryParamKeys: ['catId'],
			},
		},

		shopWomen: {
			path: '/shop/women',
			slug: 'catalog/women',
			name: 'catalogWomen',
			headerMenu: false,
			autoload: true,
			postType: {
				slug: 'products/women',
				name: 'catalogWomenProducts',
				queryParamKeys: ['catId'],
			},
		},

		singleMenProduct: {
			path: '/shop/men/:slug',
			slug: 'product',
			name: 'shop',
			singleType: 'singleProduct',
			headerMenu: false,
			autoload: true,
		},

		singleWomenProduct: {
			path: '/shop/women/:slug',
			slug: 'product',
			name: 'shop',
			singleType: 'singleProduct',
			headerMenu: false,
			autoload: true,
		},

		videos: {
			path: '/videos',
			slug: 'videos',
			name: 'videos',
			headerMenu: true,
			autoload: true,
		},

		events: {
			path: '/events',
			slug: 'events',
			name: 'events',
			headerMenu: true,
			autoload: true,
		},

		singleEvent: {
			path: '/events/:slug',
			slug: 'events',
			name: 'events',
			singleType: 'singleEvent',
			headerMenu: false,
			autoload: true,
		},

		news: {
			path: '/news',
			slug: 'posts',
			name: 'news',
			headerMenu: true,
			autoload: true,
		},

		contact: {
			path: '/contact',
			slug: 'contact',
			name: 'contact',
			headerMenu: true,
			autoload: false,
		},

		singleNews: {
			path: '/news/:slug',
			slug: 'posts',
			name: 'news',
			singleType: 'singleNews',
			headerMenu: false,
			autoload: true,
		},

		home: {
			path: '/',
			slug: 'home',
			name: 'home',
			autoload: true,
		},

		terms: {
			path: '/terms',
			slug: 'terms',
			name: 'terms',
			headerMenu: false,
			autoload: true,
		},

		policy: {
			path: '/policy',
			slug: 'policy',
			name: 'policy',
			headerMenu: false,
			autoload: true,
		},

		signIn: {
			path: '/sign-in',
			slug: 'sign-in',
			name: 'signIn',
			headerMenu: false,
			autoload: false,
		},

		signUp: {
			path: '/sign-up',
			slug: 'sign-up',
			name: 'signUp',
			headerMenu: false,
			autoload: false,
		},

		forgotPassword: {
			path: '/forgot-password',
			slug: 'forgot-password',
			name: 'forgotPassword',
			headerMenu: false,
			autoload: false,
		},

		resetPassword: {
			path: '/reset-password',
			slug: 'reset-password',
			name: 'resetPassword',
			headerMenu: false,
			autoload: false,
		},

		account: {
			path: '/account',
			slug: 'account',
			name: 'account',
			headerMenu: false,
			autoload: true,
			private: true,
		},
		accountOrders: {
			path: '/account/orders',
			slug: 'orders',
			name: 'accountOrders',
			headerMenu: false,
			autoload: true,
			private: true,
		},
		accountSingleOrder: {
			path: '/account/orders/:slug',
			slug: 'orders',
			name: 'accountSingleOrder',
			singleType: 'singleOrder',
			headerMenu: false,
			autoload: true,
			private: true,
		},
		cart: {
			path: '/cart',
			slug: 'cart',
			name: 'cart',
			headerMenu: false,
			autoload: false,
		},

		checkout: {
			path: '/checkout',
			slug: 'checkout',
			name: 'checkout',
			headerMenu: false,
			autoload: false,
		},

		chumbaluckyland: {
			path: '/chumbaluckyland',
			slug: 'chumbaluckyland',
			name: 'chumbaluckyland',
			headerMenu: false,
			autoload: false,
		},
		// mcluckAndPulsz: {
		// 	path: '/mcluck&pulsz',
		// 	slug: 'mcluck&pulsz',
		// 	name: 'McLuck & Pulsz',
		// 	headerMenu: true,
		// 	autoload: false,
		// },

		appForgotPassword: {
			path: '/app/forgot-password',
			slug: 'app-forgot-password',
			name: 'appForgotPassword',
			headerMenu: false,
			autoload: false,
		},
		appResetPassword: {
			path: '/app/reset-password',
			slug: 'app-reset-password',
			name: 'appResetPassword',
			headerMenu: false,
			autoload: false,
		},
	},

	withoutHeaderFooterPages: ['/404', '/app/forgot-password', '/app/reset-password'],
}
